import { render } from "./PatientEdit.vue?vue&type=template&id=34d17bb0&scoped=true"
import script from "./PatientEdit.vue?vue&type=script&lang=js"
export * from "./PatientEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d17bb0"]])

export default __exports__